module.exports = {
    store: {
        en: "store",
        fi: "kauppa"
    },
    clickToDeleteImage: {
        en: "Click to delete image",
        fi: "Poista kuva"
    },
    clickToUploadAnImage: {
        en: "Click to upload an image",
        fi: "Lisää kuva tietokoneelta"
    },
    edit: {
        en: "Edit",
        fi: "Muokkaa"
    },
    moreContacts: {
        en: "More contacts",
        fi: "Lisää kontakteja"
    },
    reviews: {
        en: "Reviews",
        fi: "Arvostelut"
    },
    hide: {
        en: "Hide",
        fi: "Piilota"
    },
    showAll: {
        en: "Show all",
        fi: "Näytä kaikki"
    },
    noReview: {
        en: "No review",
        fi: "Ei arvosteluja"
    },
    searchPosts: {
        en: "Search posts",
        fi: "Etsi ilmoituksista"
    },
    noPostFound: {
        en: "No post found",
        fi: "Ei ilmoituksia"
    }
};